import {animateInViewport} from "./transition";

$( function() {
	$( '.load-more' ).click( function( event ) {
		event.preventDefault();
		var $this = $( this );

		var $container = $( $this.attr( 'data-load-more-container' ) );
		$container
			.find( '.hidden' )
			.slice( 0, $this.attr( 'data-load-more-items-per-page' ) )
			.each( function() {
				var $this = $( this );

				$this.removeClass( 'hidden' );
			} );
		msnry.layout();
		animateInViewport();

		if ( $container.find( '.hidden' ).length === 0 ) {
			$this.addClass( 'hidden' ).parents( '.load-more-container' ).addClass( 'hidden' );
		}
	} );

	var $loadMoreTo = $( '*[data-id="' + window.location.hash.substr( 1 ) + '"]' );
	if ( $loadMoreTo.length ) {
		while ( $loadMoreTo.hasClass( 'hidden' ) && !$( '.load-more' ).hasClass( 'hidden' ) ) {
			$( '.load-more' ).click();
		}
		$loadMoreTo.get( 0 ).scrollIntoView();
		setTimeout( function() {
			$( 'html' )
				.removeClass( 'scrolled-up' )
				.addClass( 'scrolled-down' );
		}, 500 );
	}

	$( '.load-more-item' ).click( function( event ) {
		var dataId = $( this ).attr( 'data-id' );
		if ( dataId ) {
			history.replaceState( undefined, undefined, '#' + dataId )
		}
	} );
} );
